import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * Each kind of resource a policy can apply to.
 *
 * The value is also the resource's segment prefix in a {@link Urn}, e.g.
 * `zone` in `atn:tenant_t_a:zone_z_1`.
 */
export enum ResourceType {
  Tenant = 'tenant',
  Zone = 'zone',
  App = 'app',
  Scenario = 'scenario',
  Page = 'page',
  Agent = 'agent',
  /** A tenant membership, not an identity — see {@link Urn.Parsed.User} */
  User = 'user',
}
// Needs to be before namespace is defined
const RESOURCE_TYPES: ReadonlySet<ResourceType> = new Set(
  Object.values(ResourceType) as ResourceType[],
)
export namespace ResourceType {
  export const ALL: readonly ResourceType[] = Array.from(RESOURCE_TYPES)
  export const isResourceType = TypeChecker.Factory.oneOf(RESOURCE_TYPES)
  export const assertIsResourceType: TypeAsserter<ResourceType> =
    TypeAsserter.Factory.from(isResourceType)
}
